import styled from 'styled-components';
import Modal, { StyledCloseButton, StyledModalFooter } from '@minecraft.modal';

export const StyledDragAndDropArea = styled.div`
  min-height: 200px;
  white-space: pre;
  border: 2px dashed ${({ theme }) => theme.designSystem.borderColors.default};
  height: 100%;
  padding: 3rem;
`;

export const StyledMediaUploaderModal = styled(Modal)`
  height: auto;

  .modal-header {
    height: 3.125rem;
    border-bottom: 1px solid ${({ theme }) => theme.designSystem.borderColors.default};
    align-items: center;
    padding: 0 0.625rem;
    margin: 0;

    & > .modal-title {
      color: ${({ theme }) => theme.designSystem.textColors.link};
      font-size: 0.75rem;
    }
  }

  .modal-content {
    margin: 0 auto;
    border: none;
    height: 100%;
  }

  .modal-body {
    background-color: ${({ theme }) => theme.designSystem.bgColors.card};
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
    padding: 1.625rem 0.9375rem 1.625rem;
    height: 100%;
  }

  ${StyledCloseButton} {
    color: ${({ theme, isHeaderHidden }) =>
      isHeaderHidden ? theme.designSystem.textColors.default : theme.designSystem.textColors.link};
    padding-top: 0.625rem;

    & svg {
      width: 1rem;
      height: 1rem;
    }
  }

  ${StyledModalFooter} {
    padding: 0 1rem 1rem 1rem;
  }
`;
